import React, {useEffect, useState} from 'react';
import { ClayButtonWithIcon } from '@clayui/button';
import { ClayDropDownWithItems } from '@clayui/drop-down';
import ClayTable from '@clayui/table';
import { useHistory } from 'react-router-dom';
import { deleteProductSetting } from '../../helpers/deleteProductSetting';
import { getProducts } from "../../helpers/getProducts";
import { getProductGroups } from "../../helpers/getProductGroups"; 
import {invokews} from "../../helpers/invokews";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const ProductList = ({cards, setCards}) => {

    const [groups, setGroups] = useState([]);
    const history = useHistory();

    const pushHistory = (url) => {
        history.push(url);
    };

    useEffect(() => {
        getProductGroups().then(data => {
            setGroups(data);
        });
    }, []);

    const changeState = (idProduct) => {
        if (window.confirm('¿Deseas cambiar el estado del registro?')) {
        
            const bodySend = {productSettingId: idProduct};
        
            invokews('/digitalsale.surpriseboxsetting/update-state',
                bodySend ).then(respt => {
        
            });
        }
    }

    const deleteCard = (idProduct) => {
        if (window.confirm('¿Deseas eliminar este registro?')) {
            
            deleteProductSetting(idProduct).then(respt => {
                if (respt.code == 1) {
                    getProducts(10, 1).then(cards => {
                        setCards(cards);
                    });
                } else {
                    alert(respt.message);
                }
            });
        }
    }

    const getGroupName = (groupCode) => {
        return groups.find(item => item.childCode === groupCode)?.childName || groupCode;
    }

    return (
        <div className="container-fluid-1280 sheet">
            <ClayTable hover={false}>
                <ClayTable.Head>
                    <ClayTable.Row>
                        <ClayTable.Cell headingCell>{"ID"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Grupo"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Card "}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Orden"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Activo"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{""}</ClayTable.Cell>
                    </ClayTable.Row>
                </ClayTable.Head>
                <ClayTable.Body>
                    {
                        cards.data
                        .slice() 
                        .sort((a, b) => a.order - b.order) 
                        .map(card => (
                            <ClayTable.Row key={card.id}>
                                <ClayTable.Cell>{card.id}</ClayTable.Cell>
                                <ClayTable.Cell>{getGroupName(card.group)}</ClayTable.Cell>
                                <ClayTable.Cell>{card.name}</ClayTable.Cell>
                                <ClayTable.Cell>
                                    {card.order}
                                </ClayTable.Cell>
                                <ClayTable.Cell>
                                    <label className="toggle-switch">
                                        <input className="toggle-switch-check" defaultChecked={card.status} type="checkbox"
                                               onClick={() => changeState(card.id)}/>
                                        <span aria-hidden="true" className="toggle-switch-bar">
                                            <span className="toggle-switch-handle" data-label-off="No" data-label-on="Si"></span>
                                        </span>
                                    </label>
                                </ClayTable.Cell>
                                <ClayTable.Cell>
                                    <ClayDropDownWithItems
                                        items={[
                                            {
                                                label: "Editar",
                                                onClick: () => pushHistory(`detail/${card.id}`)
                                            },
                                            {
                                                label: "Eliminar",
                                                onClick: () => deleteCard(card.id)
                                            }
                                        ]}
                                        spritemap={spritemap}
                                        trigger={
                                            <ClayButtonWithIcon
                                                displayType="unstyled"
                                                small
                                                spritemap={spritemap}
                                                symbol="ellipsis-v"
                                            />
                                        }
                                    />
                                </ClayTable.Cell>
                            </ClayTable.Row>
                        ))
                    }
                </ClayTable.Body>
            </ClayTable>
        </div>
    )
}